<template>
    <div
        id="be-tutorial"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />

            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-6">
                                <h1 class="mb-0">
                                    {{ $t("Tutorial") }}
                                </h1>
                            </div>
                            <!--div class="col-sm-6 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <button
                                            class="pulsante-nuova-gallery btn btn-primary btn-rikorda1"
                                            v-b-modal.new-gallery-modal
                                        >
                                            {{ $t("Nuovo evento") }}
                                        </button>
                                    </li>
                                </ul>
                            </div-->
                        </div>
                    </div>
                </div>

                <div class="container-fluid">
                    <div class="row">
                        <div
                            v-for="(tutorial, index) in tutorials"
                            :key="index"
                            class="col-sm-6 mt-5"
                        >
                            <div class="yt-video-wrapper">
                                <iframe
                                    width="1920"
                                    height="1080"
                                    :src="tutorial.video"
                                    frameborder="0"
                                    allowfullscreen=""
                                ></iframe>
                            </div>
                            <div class="mt-3 h6 mb-0">
                                <span class="text-uppercase text-blurikorda font-light-rikorda mr-1">Tutorial {{ index+1 }}:</span>
                                <h2 class="h6 mb-0 d-inline">{{ tutorial.description }}</h2>
                            </div>
                            <p class="mb-0 mt-1 text-blurikorda">{{ tutorial.description2 }}</p>
                        </div>
                    </div>
                </div>
            </main>

            <backend-footer />

        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";

export default {
    name: "BackendTutorial",

    components: {
        BackendHeader,
        BackendFooter
    },

    data() {
        return {
            tutorials: [
                {
                    video:
                        "https://www.youtube.com/embed/rPp89lq5gl4?rel=0&amp;showinfo=0",
                    description:
                        "Personalizza il tuo store: carica logo e watermark",
                    description2: "Logo & Watermark"
                },
                {
                    video:
                        "https://www.youtube.com/embed/5LkwTu6GV0Y?rel=0&amp;showinfo=0",
                    description:
                        "Personalizza i tuoi listini, i tipi di consegna e le modalità di pagamento",
                    description2: "Listini, Pagamenti e Consegne"
                },
                {
                    video:
                        "https://www.youtube.com/embed/A4mgYBEFRDs?rel=0&amp;showinfo=0",
                    description:
                        "Come creare, caricare e condividere un evento",
                    description2: "Condividi il tuo Evento!"
                },
                {
                    video:
                        "https://www.youtube.com/embed/hybMJplsqmA?rel=0&amp;showinfo=0",
                    description:
                        "Cosa vede il tuo cliente, l'e-commerce del tuo evento",
                    description2: "Cosa vede il tuo cliente..."
                },
                {
                    video:
                        "https://www.youtube.com/embed/VuRk4X20ozc?rel=0&amp;showinfo=0",
                    description: "Crea un Evento solo visione senza vendita",
                    description2: "Eventi solo visione (no vendita)"
                },
                {
                    video:
                        "https://www.youtube.com/embed/i-9u9QDNtAM?rel=0&amp;showinfo=0",
                    description:
                        "Crea un Nuovo Listino Libero con gli articoli che vuoi tu",
                    description2: "Listini liberi"
                }
            ]
        };
    }
};
</script>

<style>
</style>
